import React from 'react'

import {
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@material-ui/core'

import { BillingProperty } from '../../../models/Invoice/types'

interface Props {
    properties: BillingProperty[]
}

export const PropertiesTable: React.FC<Props> = ({ properties }) => {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Property</TableCell>
                        <TableCell>Billable Units</TableCell>
                        <TableCell>Rate per Unit</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {properties.map((property) => (
                        <TableRow key={property.id}>
                            <TableCell>{property.name}</TableCell>
                            <TableCell>
                                {property.billable_unit_count}
                            </TableCell>
                            <TableCell>{property.billable_unit_rate}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
